export const LTA_NOP = 0;
export const LTA_NEW = 1;
export const LTA_APPROVED = 2;
export const LTA_REJECTED = 3;
